import { createTheme } from '@mui/material/styles';

// カスタムテーマ拡張の型定義
declare module '@mui/material/styles' {
  interface Theme {
    /** RunPort ブランド共通設定 */
    runport: {
      gradient: string;
    };
    /** 大会固有設定 */
    custom: {
      gradient: string;
      adminGradient: string;
    };
  }
  interface ThemeOptions {
    runport?: {
      gradient?: string;
    };
    custom?: {
      gradient?: string;
      adminGradient?: string;
    };
  }
}

/**
 * RunPort ベーステーマ
 * runport-ui.md ガイドライン準拠
 * 各大会はこのテーマをベースにカラーを上書きする
 */
export const baseTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#FF385C',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#D12D8C',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FEFBFF',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1D1B20',
      secondary: '#49454F',
    },
  },
  typography: {
    fontFamily: "'Noto Sans JP', 'Roboto', sans-serif",
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          border: '1px solid #CAC4D0',
        },
      },
    },
  },
  runport: {
    gradient: 'linear-gradient(135deg, #FF385C 0%, #D12D8C 50%, #6A2BFF 100%)',
  },
  custom: {
    gradient: 'linear-gradient(135deg, #FF385C 0%, #D12D8C 50%, #6A2BFF 100%)',
    adminGradient: 'linear-gradient(135deg, #6A2BFF 0%, #D12D8C 50%, #FF385C 100%)',
  },
});
